var exports = {
  "kL": "container__FLA0EF",
  "R_": "heading__eTx-L2",
  "dA": "flexibleHeight__w76w3G",
};

module.exports = exports;
